module.exports = __webpack_public_path__ + "static/img/contant_2.0b8c7fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/contant_2.jpg
// module id = Y03o
// module chunks = 0